import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { AppFocusableDirective } from './directives/focusable.directive';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { RouterModule } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { DateFnsModule } from 'ngx-date-fns';

const imports = [
  CommonModule,
  TranslatePipe,
  FormsModule,
  ReactiveFormsModule,
  TooltipModule,
  RouterModule,
  LetDirective,
  DateFnsModule,
];

const standaloneComponents = [
  TopNavbarComponent,
  LoyaltyClubFooterComponent,
  LoyaltyClubHeaderComponent,
  InputErrorsComponent,
  AppFocusableDirective,
];

@NgModule({
  imports: [
    ...imports,
    ModalModule,
    ButtonsModule,
    ...standaloneComponents,
  ],
  exports: [
    ...imports,
    ...standaloneComponents,
  ],
  providers: [],
})
export class SharedModule {
}
